module.exports = __webpack_public_path__ + "img/egiftcard.1ddec3f.png";